export default __webpack_public_path__ + "static/media/car1.49a1c322.svg";